import styled from 'styled-components';

export const VideoWrapper = styled.div<{ width?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 500px;
  ${(props) => (props.width ? 'width: ' + props.width : '')};
  margin: auto;

  video {
    border-radius: 20px;
  }
`;
